/**
 * 获取url参数对象
 * @returns {{}}
 */
export function getUrlQuery() {
  const urlParams = new URLSearchParams(window.location.search);
  const ret = {};
  urlParams.forEach((v, key) => {
    if (key.endsWith("[]")) {
      const keyArr = key.substring(0, key.length - 2);
      if (ret[keyArr]) {
        ret[keyArr].push(v);
      } else {
        ret[keyArr] = [v];
      }
    } else {
      ret[key] = v;
    }
  });
  return ret;
}

/**
 * 获取url中的第一个路径
 * @param url
 * @returns {*}
 */
export function getUrlFirstPath(url){
  //移除url中的domain
  let path = url.replace(/((http|https):)?\/\/[^/]+/,'');
  //获得第一个路径
  path = path.split('/')[1];
  return path;
}
